<section>
  <!-- Loading Indicator -->
  <ngx-ui-loader
    [loaderId]="loaderId"
    bgsColor="rgb(100, 181, 246)"
    bgsPosition="center-center"
    bgsType="ball-spin"
    overlayColor="rgba(0, 0, 0, 0.1)"
  ></ngx-ui-loader>
  <!-- Header Section -->
  <div class="header-section">
    <!-- Global Search Component -->
    <app-global-search
      [config]="searchConfig"
      [dataSource]="dataSource"
      (searchChange)="onSearchChange($event)"
      (searchCleared)="onSearchCleared()">
    </app-global-search>
    
    <div class="button-container">
      <button 
        mat-raised-button 
        color="accent"
        (click)="createNewEmail()">
        <mat-icon>add</mat-icon>
        New Email
      </button>
    </div>
  </div>

  <!-- Dialog Content -->
  <mat-dialog-content>
    <!-- Table Section with virtual scroll wrapper -->
    <div class="table-container mat-elevation-z8" (scroll)="onTableScroll($event)">
      <!-- Invisible paginator required by GridBase virtual scroll -->
      <div class="invisible">
        <mat-paginator
          [pageSizeOptions]="[10, 25, 50, 100]"
          showFirstLastButtons>
        </mat-paginator>
      </div>

      <mat-table [dataSource]="dataSource" matSort fixedLayout>
        <!-- Select Column (with select all in header) -->
        <ng-container matColumnDef="select">
          <mat-header-cell *matHeaderCellDef class="col-select">
            <mat-checkbox 
              [checked]="allSelected"
              [indeterminate]="selectedItems.length > 0 && selectedItems.length < dataSource.data.length"
              (change)="toggleAllSelection()">
            </mat-checkbox>
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="col-select">
            <mat-checkbox 
              [checked]="row.isSelected"
              (change)="toggleItemSelection(row)">
            </mat-checkbox>
          </mat-cell>
        </ng-container>

        <!-- Group Column -->
        <ng-container matColumnDef="groupName">
          <mat-header-cell *matHeaderCellDef mat-sort-header sortDisabled="true" sortId="groupName">
            <span>Group</span>
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <span>{{ row.groupName }}</span>
          </mat-cell>
        </ng-container>
        <!-- Schedule Date & Time Column -->
        <ng-container matColumnDef="scheduleDateTime">
          <mat-header-cell *matHeaderCellDef mat-sort-header sortDisabled="true" sortId="scheduleDateTimeUTC">
            <span>Schedule Date & Time</span>
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            {{ row.scheduleDateTime | date:'MMM dd, yyyy h:mm a' }}
          </mat-cell>
        </ng-container>

        <!-- Time Zone Column -->
        <ng-container matColumnDef="timeZone">
          <mat-header-cell *matHeaderCellDef mat-sort-header sortDisabled="true" sortId="timeZone">
            <span>Time Zone</span>
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            {{ row.timeZone }}
          </mat-cell>
        </ng-container>

        <!-- Frequency Column -->
        <ng-container matColumnDef="frequency">
          <mat-header-cell *matHeaderCellDef mat-sort-header sortDisabled="true" sortId="frequency">
            <span>Frequency</span>
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="col-frequency">
            {{ frequencyValues[row.frequency] }}
          </mat-cell>
        </ng-container>

        <!-- Contact Emails Column -->
        <ng-container matColumnDef="contactEmails">
          <mat-header-cell *matHeaderCellDef mat-sort-header sortDisabled="true" sortId="contactEmails">
            <span>Contact Emails</span>
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <div *ngIf="row.contactEmails && row.contactEmails.length > 0; else noEmails" >
            <button mat-button color="primary"  
                [matTooltip]="row.contactEmails | tooltipList"
                [matTooltipClass]="'tooltip-list'"
                aria-label="list of recipients">
                {{ row.contactEmails[0] }}<span *ngIf="row.contactEmails.length > 1">...</span>
              </button>
            </div>
            <ng-template #noEmails>
              <span class="text-muted">No emails</span>
            </ng-template>
          </mat-cell>
        </ng-container>

        <!-- Edit Column -->
        <ng-container matColumnDef="edit">
          <mat-header-cell *matHeaderCellDef class="col-edit">
            <span>&nbsp;</span>
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="col-edit">
            <button 
              mat-icon-button 
              [disabled]="isRowDisabled(row)"
              (click)="editEmail(row)">
              <mat-icon>edit</mat-icon>
            </button>
          </mat-cell>
        </ng-container>

        <!-- Delete Column -->
        <ng-container matColumnDef="delete">
          <mat-header-cell *matHeaderCellDef class="col-delete">
            <span>&nbsp;</span>
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="col-delete">
            <button 
              mat-icon-button 
              (click)="deleteEmail(row)">
              <mat-icon>delete</mat-icon>
            </button>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row 
          *matRowDef="let row; columns: displayedColumns;"
          [class.row-disabled]="isRowDisabled(row)">
        </mat-row>
      </mat-table>
      
      <!-- Table Footer Actions -->
      <div class="table-footer-actions">
        <button 
          mat-button 
          (click)="cancelSelection()"
          [disabled]="selectedItems.length === 0">
          <mat-icon>close</mat-icon>
          Cancel
        </button>
        <button 
          mat-raised-button 
          color="warn"
          (click)="deleteSelectedEmails()"
          [disabled]="selectedItems.length === 0">
          <mat-icon>delete</mat-icon>
          Delete Selected
        </button>
      </div>
    </div>
  </mat-dialog-content>
</section>